import { EmptyExtendedUser, ExtendedUser } from './ExtendedUser';
import { User } from './User';

export interface ProxyRelatedUser {
  tmEntity: ExtendedUser;
  sharedReports: User[];
}

export const EmptyProxyRelatedUser: ProxyRelatedUser = {
  tmEntity: EmptyExtendedUser,
  sharedReports: [],
};
